import { html, nothing, unsafeCSS, type CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { LibElement } from '../lib-element';
import itemCss from './lib-toast-item.css';

@customElement('lib-toast-item')
export class LibToastItem extends LibElement {
  static override readonly styles: CSSResultGroup = [LibElement.hostStyles, unsafeCSS(itemCss)];

  @property({ reflect: true }) severity = 'information';
  @property({ reflect: true }) presentation = 'floating';
  @property() heading = '';
  @property() message = '';
  @property({ type: Number }) progress = 100;
  @property({ type: Boolean, attribute: 'show-progress' }) showProgress = false;

  override render() {
    let icon = 'warning';
    if (this.severity === 'success') icon = 'circle-tick-sign';
    else if (this.severity === 'information') icon = 'circle-information';
    return html`
      <div class=${this.heading && this.message.length > 62 ? 'info-btn-overflow' : 'info-btn'}>
        <img alt="" src=${new URL(`../wago-icons-svg/${icon}.svg`, import.meta.url).href}>
      </div>
      <div class="general-toast-content">
        ${this.heading ? html`<div class="general-toast-header">${this.heading}</div>` : nothing}
        <div class=${this.heading ? 'general-toast-body' : 'toast-body-without-title'}>${this.message}</div>
        <slot name="action"></slot>
      </div>
      <div class="close-btn"><slot name="close"></slot></div>
      ${this.showProgress ? html`<div class="general-toast-progressbar"><span style=${'width: ' + this.progress + '%;'}></span></div>` : nothing}
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'lib-toast-item': LibToastItem;
  }
}
